import { render } from "./solicitudconsulta.vue?vue&type=template&id=b2e127da"
import script from "./solicitudconsulta.vue?vue&type=script&lang=js"
export * from "./solicitudconsulta.vue?vue&type=script&lang=js"

import "./solicitudconsulta.vue?vue&type=style&index=0&id=b2e127da&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__